import React, { Component } from 'react';
import { Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import '../../Form.css';
import { getDefaultValues } from 'ra-core';

import {
  STATUSES,
  renderPhoneField,
  renderField,
  nameValidation,
  phoneValidation,
  formatPhone,
  normalizePhone,
  restClient,
  renderSelectField, required
} from '../../../common';
import DateTimeEditor from '../../../components/DateTimeEditor';

class Create extends Component {
  state = {
    disabled: false
  }

  onHashChange = (evt) => {
    const value = evt.target.value;
    const target = evt.target;
    this.setState({disabled: true}, () => {
      restClient('GET_CUSTOM', 'getJuCRMLead', {
        leadId: value
      }).then(res => {
        if (res.status === 'error') {
          target.style.backgroundColor = '#ffc6bf';
        } else if (res.status === 'success') {
          target.style.backgroundColor = '';

          this.props.changeFieldValue('email', res.result.email);
          this.props.changeFieldValue('fio', res.result.fullname);
          this.props.changeFieldValue('jucrm_id', res.result.id);
          this.props.changeFieldValue('jucrm_parent', res.result.parent_id);
          this.props.changeFieldValue('phone', res.result.phone);
          this.props.changeFieldValue('subject_text', res.result.question);
          this.props.changeFieldValue('subject', res.result.subject);
        }
        this.setState({disabled: false});
      });
    })
  }

  render() {
    const { handleSubmit, companies, submitting, subjects } = this.props;

    return (
      <form className="ScForm" onSubmit={handleSubmit}>
        <div>
          <h2>Добавление записи</h2>
          <div>
            <Field
              name="companyId"
              component="select"
              disabled
            >
              {companies.map(({ id, name }) => <option key={id} value={id}>{name}</option>)}
            </Field>
          </div>
        </div>
        <div>
          <div className="ScFormRow_50">
            <Field name="time" component={DateTimeEditor} dateDisable />
          </div>
        </div>
        <div className="ScFormRow_50">
          <div className="ScFormCol_50_left">
            <Field name="pin" component="input" type="text" disabled />
          </div>
          <div className="ScFormCol_50_right">
            <Field name="status_callcenter" component="select">
              {STATUSES.map(({ id, name, color }) => <option key={id} value={id} style={{ color }}>{name}</option>)}
            </Field>
          </div>
        </div>
        <div>
          <label>JuCRM Хэш*</label>
          <input
            name="fio"
            data-lpignore
            autoComplete="off"
            // component={renderField}
            // validate={nameValidation}
            disabled={this.state.disabled}
            type="text"
            placeholder=""
            onChange={this.onHashChange}
          />
        </div>
        <div>
          <label>ФИО*</label>
          <Field
            name="fio"
            data-lpignore
            autoComplete="off"
            component={renderField}
            validate={nameValidation}
            type="text"
            placeholder=""
          />
        </div>
        <div className="ScFormRow_50">
          <div className="ScFormCol_50_left">
            <label>Телефон*</label>
            <Field
              data-lpignore
              name="phone"
              autoComplete="off"
              type="tel"
              component={renderPhoneField}
              validate={phoneValidation}
              format={formatPhone}
              normalize={normalizePhone}
            />
          </div>
          <div className="ScFormCol_50_right">
            <label>Email</label>
            <Field name="email" autoComplete="off" component="input" type="email" placeholder="Email" />
          </div>
        </div>
        <div>
          <div className="ScFormRow_50">
            <label>Тематика</label>
            <Field name="subject_new" component={renderSelectField} validate={required}>
              <option key={null} value={null} disabled> </option>
              {subjects.map(({ key, name }) => <option key={key} value={key}>{name}</option>)}
            </Field>
          </div>
        </div>
        <div>
          <label>Тематика (Old)</label>
          <Field disabled name="subject" autoComplete="off" component="input" type="text" placeholder="" />
        </div>
        <div>
          <label>Вопрос</label>
          <Field name="subject_text" autoComplete="off" component="textarea" />
        </div>
        <div>
          <button type="submit" disabled={submitting}>
            Добавить запись
          </button>
        </div>
      </form>
    );
  }
}


let CreateForm = reduxForm({
  form: 'create'
})(Create);

CreateForm = connect((state, props) => ({
  initialValues: getDefaultValues(state, props),
  saving: props.saving || state.admin.saving,
}),
(dispatch) => ({
  changeFieldValue(field, value) {
    dispatch(change('create', field, value));
  }
}
))(CreateForm);

export default CreateForm;



// WEBPACK FOOTER //
// ./src/pages/admin/customer/Create.js